<template>
  <div class="membership-management">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>会员管理</span>
          <el-button type="primary" @click="handleCreate">新增会员</el-button>
        </div>
      </template>

      <el-tabs v-model="activeTab" @tab-change="handleTabChange">
        <el-tab-pane label="会员列表" name="membership">
          <!-- 会员列表 -->
          <div>
        <!-- 搜索表单 -->
        <el-form :inline="true" :model="queryParams" class="search-form">
          <el-form-item label="关键词">
            <el-input
              v-model="queryParams.username"
              placeholder="用户名/真实姓名/手机号"
              clearable
              @keyup.enter="handleSearch"
              style="width: 220px"
            />
          </el-form-item>
          <el-form-item label="会员等级">
            <el-select v-model="queryParams.memberLevel" placeholder="全部" clearable style="width: 160px">
              <el-option label="普通用户" value="FREE" />
              <el-option label="试用黄金会员" value="TRIAL_GOLD" />
              <el-option label="黄金会员" value="GOLD" />
              <el-option label="钻石会员" value="DIAMOND" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="queryParams.status" placeholder="全部" clearable style="width: 130px">
              <el-option label="正常" :value="1" />
              <el-option label="已过期" :value="0" />
              <el-option label="已冻结" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否自动续费">
            <el-select v-model="queryParams.wechatAutoRenew" placeholder="全部" clearable style="width: 130px">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" :icon="Search">查询</el-button>
            <el-button @click="handleReset" :icon="Refresh">重置</el-button>
          </el-form-item>
        </el-form>

        <!-- 会员列表 -->
        <el-table
          v-loading="loading"
          :data="membershipList"
          border
          style="width: 100%"
          empty-text="暂无会员数据"
        >
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="username" label="用户名" width="120" />
          <el-table-column prop="realName" label="真实姓名" width="120" />
          <el-table-column prop="phone" label="手机号" width="120" />
          <el-table-column prop="companyName" label="所属企业" width="150" show-overflow-tooltip />
          <el-table-column prop="memberLevelName" label="会员等级" width="140">
            <template #default="{ row }">
              <el-tag :type="getLevelTagType(row.memberLevel)" size="small">
                {{ getMemberLevelName(row.memberLevel) || row.memberLevelName || row.memberLevel }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="totalRecharge" label="累计充值(元)" width="120">
            <template #default="{ row }">
              {{ formatMoney(row.totalRecharge) }}
            </template>
          </el-table-column>
          <el-table-column prop="expireTime" label="到期时间" width="180">
            <template #default="{ row }">
              {{ row.expireTime ? formatDateTime(row.expireTime) : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="wechatAutoRenew" label="自动续费" width="100">
            <template #default="{ row }">
              {{ row.wechatAutoRenew === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="getStatusTagType(row.status)">
                {{ getStatusName(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" :width="isSalesman ? '320' : '280'" fixed="right">
            <template #default="{ row }">
              <div class="action-buttons">
                <el-button type="primary" size="small" @click="handleEdit(row)">编辑</el-button>
                <el-button type="warning" size="small" @click="handleViewQuota(row)">额度</el-button>
                <el-dropdown trigger="click" @command="handleDropdownCommand">
                  <el-button type="info" size="small">
                    更多<el-icon class="el-icon--right"><arrow-down /></el-icon>
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item 
                        :command="{action: 'toggleStatus', row: row}"
                      >
                        <el-icon><Switch /></el-icon>
                        {{ row.status === 1 ? '冻结' : '解冻' }}
                      </el-dropdown-item>
                      <el-dropdown-item 
                        :command="{action: 'viewRecharge', row: row}"
                      >
                        <el-icon><List /></el-icon>
                        充值记录
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            v-model:current-page="queryParams.pageNum"
            v-model:page-size="queryParams.pageSize"
            :total="total"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          />
        </div>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="充值记录" name="recharge">
          <!-- 充值记录列表 -->
          <div>
        <!-- 搜索表单 -->
        <el-form :inline="true" :model="rechargeQueryParams" class="search-form">
          <el-form-item label="关键词">
            <el-input
              v-model="rechargeQueryParams.username"
              placeholder="用户名/手机号"
              clearable
              @keyup.enter="handleRechargeSearch"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="订单号">
            <el-input
              v-model="rechargeQueryParams.orderNo"
              placeholder="请输入订单号"
              clearable
              @keyup.enter="handleRechargeSearch"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="rechargeQueryParams.status" placeholder="全部" clearable style="width: 120px">
              <el-option label="待支付" value="PENDING" />
              <el-option label="成功" value="SUCCESS" />
              <el-option label="失败" value="FAILED" />
              <el-option label="已退款" value="REFUNDED" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleRechargeSearch">查询</el-button>
            <el-button @click="handleRechargeReset">重置</el-button>
          </el-form-item>
        </el-form>

        <!-- 充值记录操作栏 -->
        <div style="margin-bottom: 20px;">
          <el-button type="primary" @click="handleCreateRecharge">新增充值记录</el-button>
        </div>

        <!-- 充值记录列表 -->
        <el-table
          v-loading="rechargeLoading"
          :data="rechargeList"
          border
          style="width: 100%"
          empty-text="暂无充值记录"
        >
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="orderNo" label="订单号" width="180" />
          <el-table-column prop="username" label="用户名" width="120" />
          <el-table-column prop="realName" label="真实姓名" width="120" />
          <el-table-column prop="phone" label="手机号" width="120" />
          <el-table-column prop="amount" label="充值金额(元)" width="120">
            <template #default="{ row }">
              <span style="color: #67c23a; font-weight: bold;">{{ formatMoney(row.amount) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="paymentMethod" label="支付方式" width="100">
            <template #default="{ row }">
              {{ getPaymentMethodName(row.paymentMethod) }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag :type="getRechargeStatusTagType(row.status)">
                {{ getRechargeStatusName(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- 隐藏充值前余额和充值后余额列 -->
          <!-- <el-table-column prop="balanceBefore" label="充值前余额" width="120">
            <template #default="{ row }">
              {{ formatMoney(row.balanceBefore) }}
            </template>
          </el-table-column>
          <el-table-column prop="balanceAfter" label="充值后余额" width="120">
            <template #default="{ row }">
              {{ formatMoney(row.balanceAfter) }}
            </template>
          </el-table-column> -->
          <el-table-column prop="operatorName" label="操作人" width="120" />
          <el-table-column prop="createTime" label="创建时间" width="180">
            <template #default="{ row }">
              {{ formatDateTimeWithTime(row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" fixed="right">
            <template #default="{ row }">
              <el-button type="primary" size="small" @click="handleEditRecharge(row)">编辑</el-button>
              <el-button
                v-if="row.status === 'SUCCESS' && (row.paymentMethod === 'WECHAT' || row.paymentMethod === '微信')"
                type="warning"
                size="small"
                @click="handleRefundRecharge(row)"
              >
                退款
              </el-button>
              <el-tooltip v-else-if="row.status === 'SUCCESS'" content="仅支持微信支付订单的原路退款" placement="top">
                <el-button type="warning" size="small" disabled>退款</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            v-model:current-page="rechargeQueryParams.pageNum"
            v-model:page-size="rechargeQueryParams.pageSize"
            :total="rechargeTotal"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleRechargeSizeChange"
            @current-change="handleRechargePageChange"
          />
        </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 新增/编辑会员对话框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="dialogTitle"
      width="800px"
      @close="handleDialogClose"
    >
      <el-form
        ref="membershipFormRef"
        :model="membershipForm"
        :rules="membershipFormRules"
        label-width="100px"
        label-position="right"
      >
        <!-- 新增时的企业用户选择 -->
        <template v-if="!membershipForm.id">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所属企业" prop="companyId">
                <el-select
                  v-model="membershipForm.companyId"
                  placeholder="请选择所属企业（可不选）"
                  filterable
                  :loading="companyLoading"
                  style="width: 100%"
                  @change="handleCompanySelect"
                >
                  <el-option
                    v-for="company in companyOptions"
                    :key="company.id"
                    :label="company.companyName"
                    :value="company.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择用户" prop="userId">
                <el-select
                  v-model="membershipForm.userId"
                  placeholder="请选择用户（未选企业时仅显示无企业用户）"
                  filterable
                  :loading="userSearchLoading"
                  style="width: 100%"
                  @change="handleUserSelect"
                  @focus="handleUserSelectFocus"
                >
                  <el-option
                    v-for="user in userOptions"
                    :key="user.id"
                    :label="`${user.username} (${user.realName})`"
                    :value="user.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        
        <!-- 编辑时的用户信息显示 -->
        <template v-else>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="用户名">
                <el-input v-model="membershipForm.username" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="真实姓名" prop="realName">
                <el-input v-model="membershipForm.realName" placeholder="请输入真实姓名" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="membershipForm.phone" placeholder="请输入手机号" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        
        <!-- 会员基本信息 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="会员等级" prop="memberLevel">
              <el-select v-model="membershipForm.memberLevel" placeholder="请选择会员等级" style="width: 100%">
                <el-option label="普通用户" value="FREE" />
                <el-option label="试用黄金会员" value="TRIAL_GOLD" />
                <el-option label="黄金会员" value="GOLD" />
                <el-option label="钻石会员" value="DIAMOND" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到期时间" prop="expireTime">
              <el-date-picker
                v-model="membershipForm.expireTime"
                type="date"
                placeholder="选择到期日期"
                style="width: 100%"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 状态设置 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="微信自动续费">
              <el-radio-group v-model="membershipForm.wechatAutoRenew">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="membershipForm.status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">已过期</el-radio>
                <el-radio :label="2">已冻结</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 备注 -->
        <el-form-item label="备注">
          <el-input
            v-model="membershipForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>

    <!-- 额度查看对话框 -->
    <el-dialog
      v-model="quotaDialogVisible"
      title="会员额度使用情况"
      width="700px"
    >
      <div v-loading="quotaLoading">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="会员等级" :span="2">
            <el-tag :type="getLevelTagType(quotaData.memberLevel)" size="small">
              {{ getMemberLevelName(quotaData.memberLevel) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="客户数">
            {{ quotaData.customerQuota?.used || 0 }} / {{ quotaData.customerQuota?.limit === null ? '无限制' : (quotaData.customerQuota?.limit || 0) }}
            <el-tag v-if="quotaData.customerQuota?.exceeded" type="danger" size="small" style="margin-left: 10px">已超限</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="跟进数">
            {{ quotaData.followQuota?.used || 0 }} / {{ quotaData.followQuota?.limit === null ? '无限制' : (quotaData.followQuota?.limit || 0) }}
            <el-tag v-if="quotaData.followQuota?.exceeded" type="danger" size="small" style="margin-left: 10px">已超限</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="成交台账数">
            {{ quotaData.dealQuota?.used || 0 }} / {{ quotaData.dealQuota?.limit === null ? '无限制' : (quotaData.dealQuota?.limit || 0) }}
            <el-tag v-if="quotaData.dealQuota?.exceeded" type="danger" size="small" style="margin-left: 10px">已超限</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="合同数">
            {{ quotaData.contractQuota?.used || 0 }} / {{ quotaData.contractQuota?.limit === null ? '无限制' : (quotaData.contractQuota?.limit || 0) }}
            <el-tag v-if="quotaData.contractQuota?.exceeded" type="danger" size="small" style="margin-left: 10px">已超限</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="附件数">
            {{ quotaData.attachmentQuota?.used || 0 }} / {{ quotaData.attachmentQuota?.limit === null ? '无限制' : (quotaData.attachmentQuota?.limit || 0) }}
            <el-tag v-if="quotaData.attachmentQuota?.exceeded" type="danger" size="small" style="margin-left: 10px">已超限</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="名片扫描次数">
            {{ quotaData.cardScanQuota?.used || 0 }} / {{ quotaData.cardScanQuota?.limit === null ? '无限制' : (quotaData.cardScanQuota?.limit || 0) }}
            <el-tag v-if="quotaData.cardScanQuota?.exceeded" type="danger" size="small" style="margin-left: 10px">已超限</el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <template #footer>
        <el-button @click="quotaDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 充值对话框 -->
    <el-dialog
      v-model="rechargeDialogVisible"
      title="会员充值"
      width="500px"
      @close="handleRechargeDialogClose"
    >
      <el-form
        ref="rechargeFormRef"
        :model="rechargeForm"
        :rules="rechargeFormRules"
        label-width="100px"
      >
        <el-form-item v-if="!rechargeForm.id" label="选择会员" prop="membershipId">
          <el-select
            v-model="rechargeForm.membershipId"
            placeholder="请选择会员"
            filterable
            style="width: 100%"
            @change="handleMembershipSelect"
          >
            <el-option
              v-for="member in membershipList"
              :key="member.id"
              :label="`${member.username} (${member.realName}) - 余额: ${formatMoney(member.balance)}`"
              :value="member.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="rechargeForm.id || rechargeForm.membershipId" label="会员信息">
          <div>{{ rechargeForm.username }} ({{ rechargeForm.realName }})</div>
        </el-form-item>
        <el-form-item v-if="rechargeForm.id || rechargeForm.membershipId" label="当前余额(元)">
          <div>{{ formatMoney(rechargeForm.currentBalance) }}</div>
        </el-form-item>
        <el-form-item label="充值金额(元)" prop="amount">
          <el-input-number
            v-model="rechargeForm.amount"
            :min="0.01"
            :precision="2"
            style="width: 100%"
            placeholder="请输入充值金额"
          />
        </el-form-item>
        <el-form-item label="支付方式" prop="paymentMethod">
          <el-select v-model="rechargeForm.paymentMethod" placeholder="请选择支付方式" style="width: 100%">
            <el-option label="支付宝" value="ALIPAY" />
            <el-option label="微信" value="WECHAT" />
            <el-option label="银行转账" value="BANK" />
            <el-option label="其他" value="OTHER" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="rechargeForm.id" label="状态" prop="status">
          <el-select v-model="rechargeForm.status" placeholder="请选择状态" style="width: 100%">
            <el-option label="待支付" value="PENDING" />
            <el-option label="成功" value="SUCCESS" />
            <el-option label="失败" value="FAILED" />
            <el-option label="已退款" value="REFUNDED" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付订单号">
          <el-input
            v-model="rechargeForm.paymentOrderNo"
            placeholder="请输入第三方支付订单号（可选）"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="rechargeForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="rechargeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleRechargeSubmit">确定</el-button>
      </template>
    </el-dialog>

    <!-- 退款对话框 -->
    <el-dialog
      v-model="refundDialogVisible"
      title="申请退款"
      width="440px"
      @close="handleRefundDialogClose"
    >
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 16px;"
      >
        退款将通过微信支付原路退至用户微信零钱，请确认退款金额。
      </el-alert>
      <el-form
        ref="refundFormRef"
        :model="refundForm"
        :rules="refundFormRules"
        label-width="100px"
      >
        <el-form-item label="订单号">
          <span>{{ refundForm.orderNo || '-' }}</span>
        </el-form-item>
        <el-form-item label="充值金额(元)">
          <span style="color: #67c23a; font-weight: bold;">{{ formatMoney(refundForm.amount) }}</span>
        </el-form-item>
        <el-form-item label="退款金额(元)" prop="refundAmount">
          <el-input-number
            v-model="refundForm.refundAmount"
            :min="0.01"
            :max="refundForm.amount ? Number(refundForm.amount) : 999999"
            :precision="2"
            style="width: 100%"
            placeholder="请输入退款金额"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="refundDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="refundSubmitting" @click="handleRefundSubmit">确认退款</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ArrowDown, Switch, List, Search, Refresh } from '@element-plus/icons-vue'
import {
  getMembershipList,
  getMembershipById,
  createMembership,
  updateMembership,
  updateMembershipStatus,
  recharge,
  createRecharge,
  updateRecharge,
  refundRecharge,
  getRechargeList,
  getRechargeById,
  getMembershipQuota
} from '../api/membership'
import { getUserList } from '../api/sysUser'
import { getAllCompanies } from '../api/company'

// 用户类型判断
const isSalesman = ref(false)

// 数据
const activeTab = ref('membership')
const loading = ref(false)
const membershipList = ref([])
const total = ref(0)
const queryParams = reactive({
  username: '',
  memberLevel: '',
  status: null,
  wechatAutoRenew: null,
  pageNum: 1,
  pageSize: 10
})

const rechargeLoading = ref(false)
const rechargeList = ref([])
const rechargeTotal = ref(0)
const rechargeQueryParams = reactive({
  username: '',
  orderNo: '',
  status: '',
  pageNum: 1,
  pageSize: 10
})

// 对话框
const dialogVisible = ref(false)
const dialogTitle = ref('编辑会员')
const membershipFormRef = ref(null)
const membershipForm = reactive({
  id: null,
  companyId: null,
  userId: null,
  username: '',
  realName: '',
  phone: '',
  memberLevel: '',
  balance: 0,
  expireTime: '',
  wechatAutoRenew: 0,
  status: 1,
  remark: ''
})

// 企业列表
const companyOptions = ref([])
const companyLoading = ref(false)

// 用户搜索
const userSearchLoading = ref(false)
const userOptions = ref([])

const membershipFormRules = {
  userId: [
    { required: true, message: '请选择用户', trigger: 'change' }
  ],
  realName: [
    { required: false, message: '请输入真实姓名', trigger: 'blur' }
  ],
  phone: [
    { required: false, message: '请输入手机号', trigger: 'blur' },
    { 
      pattern: /^1[3-9]\d{9}$/, 
      message: '手机号格式不正确', 
      trigger: 'blur' 
    }
  ],
  memberLevel: [
    { required: true, message: '请选择会员等级', trigger: 'change' }
  ],
  expireTime: [
    { required: true, message: '请选择到期时间', trigger: 'change' }
  ],
  status: [
    { required: true, message: '请选择状态', trigger: 'change' }
  ]
}

const rechargeDialogVisible = ref(false)
const rechargeDialogTitle = ref('会员充值')
const rechargeFormRef = ref(null)
const rechargeForm = reactive({
  id: null,
  membershipId: null,
  username: '',
  realName: '',
  currentBalance: 0,
  amount: null,
  paymentMethod: 'OTHER',
  paymentOrderNo: '',
  status: 'PENDING',
  remark: ''
})

const rechargeFormRules = {
  membershipId: [
    { required: true, message: '请选择会员', trigger: 'change' }
  ],
  amount: [
    { required: true, message: '请输入充值金额', trigger: 'blur' },
    { type: 'number', min: 0.01, message: '充值金额必须大于0', trigger: 'blur' }
  ],
  paymentMethod: [
    { required: true, message: '请选择支付方式', trigger: 'change' }
  ],
  status: [
    { required: true, message: '请选择状态', trigger: 'change' }
  ]
}

// 退款对话框
const refundDialogVisible = ref(false)
const refundFormRef = ref(null)
const refundSubmitting = ref(false)
const refundForm = reactive({
  id: null,
  orderNo: '',
  amount: null,
  refundAmount: null
})
const refundFormRules = {
  refundAmount: [
    { required: true, message: '请输入退款金额', trigger: 'blur' },
    { type: 'number', min: 0.01, message: '退款金额必须大于0', trigger: 'blur' }
  ]
}

// 额度查看相关
const quotaDialogVisible = ref(false)
const quotaLoading = ref(false)
const quotaData = reactive({
  userId: null,
  memberLevel: '',
  customerQuota: null,
  followQuota: null,
  dealQuota: null,
  contractQuota: null,
  attachmentQuota: null,
  cardScanQuota: null
})

// 方法
const formatDateTime = (dateTime) => {
  if (!dateTime) return '-'
  const date = new Date(dateTime)
  // 只显示日期，不显示时分秒
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 带时分秒（用于充值记录创建时间等）
const formatDateTimeWithTime = (dateTime) => {
  if (!dateTime) return '-'
  const date = new Date(dateTime)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

const formatMoney = (money) => {
  if (money == null) return '0.00'
  return parseFloat(money).toFixed(2)
}

const getLevelTagType = (level) => {
  const typeMap = {
    'FREE': 'info',
    'TRIAL_GOLD': 'warning',
    'GOLD': 'warning',
    'DIAMOND': 'danger'
  }
  return typeMap[level] || 'info'
}

const getStatusName = (status) => {
  const statusMap = {
    0: '已过期',
    1: '正常',
    2: '已冻结'
  }
  return statusMap[status] || '未知'
}

const getStatusTagType = (status) => {
  const typeMap = {
    0: 'warning',
    1: 'success',
    2: 'danger'
  }
  return typeMap[status] || ''
}

const getPaymentMethodName = (method) => {
  const methodMap = {
    'ALIPAY': '支付宝',
    'WECHAT': '微信',
    'BANK': '银行转账',
    'OTHER': '其他'
  }
  return methodMap[method] || method
}

const getRechargeStatusName = (status) => {
  const statusMap = {
    'PENDING': '待支付',
    'SUCCESS': '成功',
    'FAILED': '失败',
    'REFUNDED': '已退款'
  }
  return statusMap[status] || status
}

const getRechargeStatusTagType = (status) => {
  const typeMap = {
    'PENDING': 'warning',
    'SUCCESS': 'success',
    'FAILED': 'danger',
    'REFUNDED': 'info'
  }
  return typeMap[status] || ''
}

const loadMembershipList = async () => {
  loading.value = true
  try {
    console.log('开始加载会员列表，查询参数:', queryParams)
    const res = await getMembershipList(queryParams)
    console.log('会员列表API响应:', res)
    if (res && res.code === '000000') {
      // 处理分页数据
      if (res.data) {
        // 如果 data 是分页对象
        if (res.data.records) {
          membershipList.value = res.data.records || []
          total.value = res.data.total || 0
        } 
        // 如果 data 直接是数组（兼容处理）
        else if (Array.isArray(res.data)) {
          membershipList.value = res.data
          total.value = res.data.length
        } 
        // 其他情况
        else {
          membershipList.value = []
          total.value = 0
        }
      } else {
        membershipList.value = []
        total.value = 0
      }
      console.log('会员列表加载成功，共', total.value, '条记录')
    } else {
      const errorMsg = res?.msg || res?.message || '获取会员列表失败'
      console.error('获取会员列表失败:', errorMsg)
      ElMessage.error(errorMsg)
      membershipList.value = []
      total.value = 0
    }
  } catch (error) {
    console.error('获取会员列表异常:', error)
    const errorMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '未知错误'
    ElMessage.error('获取会员列表失败: ' + errorMsg)
    membershipList.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

const handleSearch = () => {
  queryParams.pageNum = 1
  loadMembershipList()
}

const handleReset = () => {
  queryParams.username = ''
  queryParams.memberLevel = ''
  queryParams.status = null
  queryParams.wechatAutoRenew = null
  queryParams.pageNum = 1
  loadMembershipList()
}

const handleCreate = async () => {
  dialogTitle.value = '新增会员'
  Object.assign(membershipForm, {
    id: null,
    companyId: null,
    userId: null,
    username: '',
    realName: '',
    phone: '',
    memberLevel: 'FREE',
    balance: 0,
    expireTime: '',
    wechatAutoRenew: 0,
    status: 1,
    remark: ''
  })
  userOptions.value = []
  // 加载企业列表
  await loadCompanyList()
  dialogVisible.value = true
}

// 加载企业列表
const loadCompanyList = async () => {
  companyLoading.value = true
  try {
    const res = await getAllCompanies()
    if (res && res.code === '000000') {
      companyOptions.value = res.data || []
    } else {
      ElMessage.error(res?.msg || res?.message || '获取企业列表失败')
      companyOptions.value = []
    }
  } catch (error) {
    console.error('获取企业列表失败:', error)
    ElMessage.error('获取企业列表失败')
    companyOptions.value = []
  } finally {
    companyLoading.value = false
  }
}

// 选择企业
const handleCompanySelect = async (companyId) => {
  if (!companyId) {
    membershipForm.userId = null
    userOptions.value = []
    // 未选择企业时，后续在用户下拉获得焦点时再自动加载无企业用户
    return
  }
  // 清空用户选择
  membershipForm.userId = null
  userOptions.value = []
  // 加载该企业的用户列表
  await loadUsersByCompany(companyId)
}

// 根据企业ID加载用户列表
const loadUsersByCompany = async (companyId) => {
  if (!companyId) {
    await loadUsersWithoutCompany()
    return
  }
  userSearchLoading.value = true
  try {
    const res = await getUserList({
      companyId: companyId,
      pageNum: 1,
      pageSize: 1000 // 获取所有用户
    })
    if (res && res.code === '000000') {
      userOptions.value = res.data?.records || []
    } else {
      ElMessage.error(res?.msg || res?.message || '获取用户列表失败')
      userOptions.value = []
    }
  } catch (error) {
    console.error('获取用户列表失败:', error)
    ElMessage.error('获取用户列表失败')
    userOptions.value = []
  } finally {
    userSearchLoading.value = false
  }
}

// 加载无所属企业的用户列表
const loadUsersWithoutCompany = async () => {
  userSearchLoading.value = true
  try {
    const res = await getUserList({
      without_company: true,
      pageNum: 1,
      pageSize: 1000
    })
    if (res && res.code === '000000') {
      userOptions.value = res.data?.records || []
    } else {
      ElMessage.error(res?.msg || res?.message || '获取用户列表失败')
      userOptions.value = []
    }
  } catch (error) {
    console.error('获取用户列表失败:', error)
    ElMessage.error('获取用户列表失败')
    userOptions.value = []
  } finally {
    userSearchLoading.value = false
  }
}

// 用户下拉框获得焦点时的处理
const handleUserSelectFocus = async () => {
  if (membershipForm.companyId) {
    if (!userOptions.value.length) {
      await loadUsersByCompany(membershipForm.companyId)
    }
  } else {
    await loadUsersWithoutCompany()
  }
}

const handleEdit = async (row) => {
  try {
    const res = await getMembershipById(row.id)
    if (res.code === '000000') {
      const data = res.data
      dialogTitle.value = '编辑会员'
      // 处理到期时间，只取日期部分
      let expireTime = ''
      if (data.expireTime) {
        const date = new Date(data.expireTime)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        expireTime = `${year}-${month}-${day}`
      }
      Object.assign(membershipForm, {
        id: data.id,
        userId: data.userId,
        username: data.username || '',
        realName: data.realName || '',
        phone: data.phone || '',
        memberLevel: data.memberLevel || '',
        balance: data.balance || 0,
        expireTime: expireTime,
        wechatAutoRenew: data.wechatAutoRenew || 0,
        status: data.status,
        remark: data.remark || ''
      })
      dialogVisible.value = true
    }
  } catch (error) {
    console.error('获取会员详情失败:', error)
    ElMessage.error('获取会员详情失败')
  }
}

// 搜索用户（已废弃，改为根据企业查询）
// const searchUsers = async (query) => {
//   if (!query) {
//     userOptions.value = []
//     return
//   }
//   userSearchLoading.value = true
//   try {
//     const res = await getUserList({
//       username: query,
//       pageNum: 1,
//       pageSize: 20
//     })
//     if (res.code === '000000') {
//       userOptions.value = res.data?.records || []
//     }
//   } catch (error) {
//     console.error('搜索用户失败:', error)
//   } finally {
//     userSearchLoading.value = false
//   }
// }

// 选择用户
const handleUserSelect = async (userId) => {
  if (!userId) {
    membershipForm.username = ''
    membershipForm.realName = ''
    membershipForm.phone = ''
    return
  }
  // 从已加载的用户列表中找到选中的用户
  const user = userOptions.value.find(u => u.id === userId)
  if (user) {
    membershipForm.username = user.username || ''
    membershipForm.realName = user.realName || ''
    membershipForm.phone = user.phone || ''
  } else {
    // 如果没找到，尝试单独查询
    try {
      const res = await getUserList({ 
        companyId: membershipForm.companyId,
        pageNum: 1, 
        pageSize: 1000 
      })
      if (res.code === '000000') {
        const users = res.data?.records || []
        const foundUser = users.find(u => u.id === userId)
        if (foundUser) {
          membershipForm.username = foundUser.username || ''
          membershipForm.realName = foundUser.realName || ''
          membershipForm.phone = foundUser.phone || ''
        }
      }
    } catch (error) {
      console.error('获取用户信息失败:', error)
    }
  }
}

const handleSubmit = async () => {
  if (!membershipFormRef.value) return
  await membershipFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        if (membershipForm.id) {
          // 更新会员
          const data = {
            id: membershipForm.id,
            memberLevel: membershipForm.memberLevel,
            balance: membershipForm.balance,
            expireTime: membershipForm.expireTime || null,
            wechatAutoRenew: membershipForm.wechatAutoRenew,
            status: membershipForm.status,
            remark: membershipForm.remark || null,
            realName: membershipForm.realName || null,
            phone: membershipForm.phone || null
          }
          // 移除空字符串，转换为 null
          Object.keys(data).forEach(key => {
            if (data[key] === '') {
              data[key] = null
            }
          })
          const res = await updateMembership(data)
          if (res.code === '000000') {
            ElMessage.success('更新成功')
            dialogVisible.value = false
            loadMembershipList()
          }
        } else {
          // 新增会员
          const data = {
            userId: membershipForm.userId,
            memberLevel: membershipForm.memberLevel,
            balance: membershipForm.balance,
            expireTime: membershipForm.expireTime || null,
            wechatAutoRenew: membershipForm.wechatAutoRenew,
            status: membershipForm.status,
            remark: membershipForm.remark || null
          }
          // 移除空字符串，转换为 null
          Object.keys(data).forEach(key => {
            if (data[key] === '') {
              data[key] = null
            }
          })
          console.log('提交的会员数据:', data)
          const res = await createMembership(data)
          if (res.code === '000000') {
            ElMessage.success('新增成功')
            dialogVisible.value = false
            loadMembershipList()
          }
        }
      } catch (error) {
        console.error('操作失败:', error)
        const errorMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '操作失败'
        ElMessage.error(errorMsg)
      }
    }
  })
}

const handleDialogClose = () => {
  membershipFormRef.value?.resetFields()
}

const handleCreateRecharge = () => {
  rechargeDialogTitle.value = '新增充值记录'
  Object.assign(rechargeForm, {
    id: null,
    membershipId: null,
    username: '',
    realName: '',
    currentBalance: 0,
    amount: null,
    paymentMethod: 'OTHER',
    paymentOrderNo: '',
    status: 'PENDING',
    remark: ''
  })
  rechargeDialogVisible.value = true
}

const handleEditRecharge = async (row) => {
  try {
    const res = await getRechargeById(row.id)
    if (res.code === '000000') {
      const data = res.data
      rechargeDialogTitle.value = '编辑充值记录'
      Object.assign(rechargeForm, {
        id: data.id,
        membershipId: data.membershipId,
        username: data.username || '',
        realName: data.realName || '',
        currentBalance: data.balanceAfter || 0,
        amount: data.amount || null,
        paymentMethod: data.paymentMethod || 'OTHER',
        paymentOrderNo: data.paymentOrderNo || '',
        status: data.status || 'PENDING',
        remark: data.remark || ''
      })
      rechargeDialogVisible.value = true
    }
  } catch (error) {
    console.error('获取充值记录详情失败:', error)
    ElMessage.error('获取充值记录详情失败')
  }
}

const handleMembershipSelect = async (membershipId) => {
  if (!membershipId) return
  try {
    const res = await getMembershipById(membershipId)
    if (res.code === '000000') {
      const data = res.data
      rechargeForm.username = data.username || ''
      rechargeForm.realName = data.realName || ''
      rechargeForm.currentBalance = data.balance || 0
    }
  } catch (error) {
    console.error('获取会员信息失败:', error)
  }
}

const handleRechargeSubmit = async () => {
  if (!rechargeFormRef.value) return
  await rechargeFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        if (rechargeForm.id) {
          // 更新充值记录
          const data = {
            id: rechargeForm.id,
            amount: rechargeForm.amount,
            paymentMethod: rechargeForm.paymentMethod,
            paymentOrderNo: rechargeForm.paymentOrderNo,
            status: rechargeForm.status,
            remark: rechargeForm.remark
          }
          const res = await updateRecharge(data)
          if (res.code === '000000') {
            ElMessage.success('更新成功')
            rechargeDialogVisible.value = false
            loadRechargeList()
            loadMembershipList()
          }
        } else if (rechargeDialogTitle.value === '会员充值') {
          // 会员充值（会更新余额）
          const data = {
            membershipId: rechargeForm.membershipId,
            amount: rechargeForm.amount,
            paymentMethod: rechargeForm.paymentMethod,
            paymentOrderNo: rechargeForm.paymentOrderNo,
            remark: rechargeForm.remark
          }
          const res = await recharge(data)
          if (res.code === '000000') {
            ElMessage.success('充值成功')
            rechargeDialogVisible.value = false
            loadMembershipList()
            if (activeTab.value === 'recharge') {
              loadRechargeList()
            }
          }
        } else {
          // 新增充值记录（不更新余额）
          const data = {
            membershipId: rechargeForm.membershipId,
            amount: rechargeForm.amount,
            paymentMethod: rechargeForm.paymentMethod,
            paymentOrderNo: rechargeForm.paymentOrderNo,
            remark: rechargeForm.remark
          }
          const res = await createRecharge(data)
          if (res.code === '000000') {
            ElMessage.success('新增成功')
            rechargeDialogVisible.value = false
            loadRechargeList()
          }
        }
      } catch (error) {
        console.error('操作失败:', error)
        const errorMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '操作失败'
        ElMessage.error(errorMsg)
      }
    }
  })
}

const handleRechargeDialogClose = () => {
  rechargeFormRef.value?.resetFields()
}

const handleRefundRecharge = (row) => {
  refundForm.id = row.id
  refundForm.orderNo = row.orderNo
  refundForm.amount = row.amount
  refundForm.refundAmount = row.amount ? Number(row.amount) : null
  refundDialogVisible.value = true
}

const handleRefundDialogClose = () => {
  refundForm.id = null
  refundForm.orderNo = ''
  refundForm.amount = null
  refundForm.refundAmount = null
  refundFormRef.value?.resetFields()
}

const handleRefundSubmit = async () => {
  if (!refundFormRef.value) return
  await refundFormRef.value.validate(async (valid) => {
    if (!valid) return
    if (refundForm.refundAmount == null || Number(refundForm.refundAmount) <= 0) {
      ElMessage.warning('请输入有效的退款金额')
      return
    }
    const amountNum = refundForm.amount ? Number(refundForm.amount) : 0
    if (Number(refundForm.refundAmount) > amountNum) {
      ElMessage.warning('退款金额不能大于充值金额')
      return
    }
    refundSubmitting.value = true
    try {
      const res = await refundRecharge({
        id: refundForm.id,
        refundAmount: refundForm.refundAmount
      })
      if (res && res.code === '000000') {
        ElMessage.success('退款成功，状态已更新为已退款')
        refundDialogVisible.value = false
        loadRechargeList()
        loadMembershipList()
      } else {
        ElMessage.error(res?.msg || res?.message || '退款失败')
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '退款失败'
      ElMessage.error(errorMsg)
    } finally {
      refundSubmitting.value = false
    }
  })
}

const handleToggleStatus = async (row) => {
  const newStatus = row.status === 1 ? 2 : 1
  const action = newStatus === 2 ? '冻结' : '解冻'
  try {
    await ElMessageBox.confirm(`确定要${action}该会员吗？`, '提示', {
      type: 'warning',
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    })
    const res = await updateMembershipStatus(row.id, newStatus)
    if (res.code === '000000') {
      ElMessage.success(`${action}成功`)
      loadMembershipList()
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error(`${action}会员失败:`, error)
    }
  }
}

const handleDropdownCommand = (command) => {
  const { action, row } = command
  switch (action) {
    case 'toggleStatus':
      handleToggleStatus(row)
      break
    case 'viewRecharge':
      activeTab.value = 'recharge'
      rechargeQueryParams.username = row.username
      loadRechargeList()
      break
  }
}

const handleSizeChange = (size) => {
  queryParams.pageSize = size
  loadMembershipList()
}

const handlePageChange = (page) => {
  queryParams.pageNum = page
  loadMembershipList()
}

// 充值记录相关方法
const loadRechargeList = async () => {
  rechargeLoading.value = true
  try {
    const res = await getRechargeList(rechargeQueryParams)
    if (res && res.code === '000000') {
      rechargeList.value = res.data?.records || []
      rechargeTotal.value = res.data?.total || 0
    } else {
      ElMessage.error(res?.msg || res?.message || '获取充值记录列表失败')
      rechargeList.value = []
      rechargeTotal.value = 0
    }
  } catch (error) {
    console.error('获取充值记录列表失败:', error)
    const errorMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '未知错误'
    ElMessage.error('获取充值记录列表失败: ' + errorMsg)
    rechargeList.value = []
    rechargeTotal.value = 0
  } finally {
    rechargeLoading.value = false
  }
}

const handleRechargeSearch = () => {
  rechargeQueryParams.pageNum = 1
  loadRechargeList()
}

const handleRechargeReset = () => {
  rechargeQueryParams.username = ''
  rechargeQueryParams.orderNo = ''
  rechargeQueryParams.status = ''
  rechargeQueryParams.pageNum = 1
  loadRechargeList()
}

const handleRechargeSizeChange = (size) => {
  rechargeQueryParams.pageSize = size
  loadRechargeList()
}

const handleRechargePageChange = (page) => {
  rechargeQueryParams.pageNum = page
  loadRechargeList()
}

const handleTabChange = (tabName) => {
  if (tabName === 'recharge') {
    loadRechargeList()
  } else {
    loadMembershipList()
  }
}

// 查看额度
const handleViewQuota = async (row) => {
  quotaDialogVisible.value = true
  quotaLoading.value = true
  try {
    const res = await getMembershipQuota(row.id)
    if (res.code === '000000') {
      const data = res.data
      Object.assign(quotaData, {
        userId: data.userId,
        memberLevel: data.memberLevel,
        customerQuota: data.customerQuota,
        followQuota: data.followQuota,
        dealQuota: data.dealQuota,
        contractQuota: data.contractQuota,
        attachmentQuota: data.attachmentQuota,
        cardScanQuota: data.cardScanQuota
      })
    } else {
      ElMessage.error(res?.msg || res?.message || '获取额度信息失败')
    }
  } catch (error) {
    console.error('获取额度信息失败:', error)
    const errorMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '未知错误'
    ElMessage.error('获取额度信息失败: ' + errorMsg)
  } finally {
    quotaLoading.value = false
  }
}

// 获取会员等级名称
const getMemberLevelName = (memberLevel) => {
  if (!memberLevel) return ''
  const levelMap = {
    'FREE': '普通用户',
    'TRIAL_GOLD': '试用黄金会员',
    'GOLD': '黄金会员',
    'DIAMOND': '钻石会员'
  }
  return levelMap[memberLevel] || memberLevel
}

// 生命周期
onMounted(() => {
  // 获取用户类型
  try {
    const userInfoStr = localStorage.getItem('userInfo')
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr)
      isSalesman.value = userInfo.userType === 'SALESMAN'
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
  }
  loadMembershipList()
})
</script>

<style scoped>
.membership-management {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.action-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: nowrap;
}

.action-buttons .el-button {
  margin: 0;
  flex-shrink: 0;
}

.membership-management :deep(.el-dialog__body) {
  padding: 24px 20px;
}

.membership-management :deep(.el-form-item) {
  margin-bottom: 20px;
}

.membership-management :deep(.el-form-item__label) {
  font-weight: 500;
}
</style>

